import React from "react"
import Header from "../components/Global/Header/Header"
import Footer from "../components/Global/Footer/Footer"

const Layout = ({ children }) => {
  return (
    <div className="layout--container bg-white">
      <Header />
      <main className="max-w-container" id="main">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
